import React from 'react';
import { Expand } from 'lucide-react';
import { proofCategoryLabel, proofDate } from '../data/salesProofs';
import { SalesProofImage } from './SalesProofImage';

export const SalesProofCard = ({ proof, onView }) => (
  <article className="min-w-0 flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white transition-shadow duration-200 hover:shadow-lg" data-testid={`salesproof-card-${proof.id}`}>
    <button
      type="button"
      onClick={(event) => onView(proof, event)}
      aria-label={`View screenshot: ${proof.title}`}
      className="relative block w-full aspect-[4/3] shrink-0 border-b border-gray-200 bg-gray-50 hover:bg-gray-100 transition-colors"
      data-testid={`salesproof-image-button-${proof.id}`}
    >
      <span className="absolute inset-0 p-4">
        <SalesProofImage proof={proof} testId={`salesproof-image-${proof.id}`} className="w-full h-full object-contain" />
      </span>
    </button>
    <div className="flex flex-1 flex-col p-5 sm:p-6">
      <p className="mb-3 text-xs font-semibold uppercase text-gray-600" data-testid={`salesproof-category-${proof.id}`}>{proofCategoryLabel(proof.category)}</p>
      <p className="mb-3 text-2xl font-bold text-[#0D234E] break-words" data-testid={`salesproof-metric-${proof.id}`}>{proof.metrics}</p>
      <h2 className="mb-3 text-base md:text-lg font-bold leading-snug text-[#0D234E]" data-testid={`salesproof-title-${proof.id}`}>{proof.title}</h2>
      <p className="mb-5 text-sm leading-relaxed text-gray-600 line-clamp-3" data-testid={`salesproof-description-${proof.id}`}>{proof.description}</p>
      <div className="mt-auto">
        <p className="text-sm font-medium text-gray-700" data-testid={`salesproof-client-${proof.id}`}>{proof.client_name}</p>
        <time dateTime={proof.date} className="mt-1 block text-xs text-gray-500" data-testid={`salesproof-date-${proof.id}`}>{proofDate(proof.date)}</time>
        <button
          type="button"
          onClick={(event) => onView(proof, event)}
          className="mt-5 flex w-full items-center justify-center gap-2 rounded-md bg-[#0D234E] px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#1a3a6e]"
          aria-label={`View proof: ${proof.title}`}
          data-testid={`salesproof-view-${proof.id}`}
        >
          <Expand size={16} aria-hidden="true" /> View Proof
        </button>
      </div>
    </div>
  </article>
);